// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__1EKT9","title":"ClientReferral_title__2U57z","itemText":"ClientReferral_itemText__1Q2Cj"};